// src/views/PushMgmt.tsx

// 推送管理页面(管理员)

// 第三方
import React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'

// 自定义
import Header from './components/Header'
import Sidebar from './components/Sidebar'
import { Global } from '../services/Global'
import { browserUtil } from '../utils/BrowserUtil'
import { PushContent } from './components/PushContent'
import { Page } from '../services/Page'
import { Layout } from 'antd'

const { Content } = Layout;

class PushMgmt extends React.Component<WithTranslation> {

    state = {
        loginName: '',
    }

    componentWillMount = () => {
        Global.isMobile = browserUtil.checkMobile()
    }

    componentDidMount = () => {
    }

    changeLang = () => {
    }

    render() {
        const { t, i18n } = this.props
        return (
            <Layout style={{ minHeight: '100vh' }}>
                <Header
                    trans={t}
                    i18n={i18n}
                    loginName={this.state.loginName}
                    changeLang={this.changeLang}
                />

                <Layout>
                    <Sidebar selectMenu={Page.pushMgmt} trans={t} />
                    <Content>
                        <PushContent />
                    </Content>
                </Layout>
            </Layout>
        )
    }

}
export const PushMgmtPage = withTranslation()(PushMgmt)